import { createContext } from 'react';

const Context = createContext();

export const { Provider, Consumer } = Context;

export default Context;
